<template>
    <div v-if="signUpCompleted" class="min-w-screen min-h-screen flex items-center justify-center">
        <div class="w-[550px] h-auto bg-white rounded-lg px-[4rem] py-[3rem] flex items-center flex-col">
            <svg class="mb-4 w-12 h-12" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor"><path d="m424-296 282-282-56-56-226 226-114-114-56 56 170 170Zm56 216q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg>
            <p class="text-center">Запрос на регистрацию принят.</p>
            <p class="text-center">Проверьте ваш email для подтверждения аккаунта</p>
            <router-link :to="{'name': 'sign-in'}" class="mt-8 w-3/4 bg-custom-blue hover:bg-custom-blue-hover text-center text-white font-medium rounded-lg text-sm px-5 py-2">Хорошо</router-link>
        </div>
    </div>
    <div v-else class="min-w-screen min-h-screen flex items-center justify-center">
        <div class="w-[600px] h-auto bg-white rounded-lg px-[4rem] py-[3rem]">
            <div class="grid grid-cols-2 gap-4">
                <p class="col-span-2 text-2xl mb-4">Регистрация в системе</p>
                <TextInput v-model:textParam="username" labelContent="Email" ref="usernameInput" class="col-span-2"/>
                <TextInput v-model:textParam="name" labelContent="ФИО" ref="nameInput" class=""/>
                <PhoneInputComponent v-model:inputParam="phone" labelContent="Номер телефона" placeholder="Номер с кодом страны" ref="phoneInput" class=""/>
                <label class="cursor-pointer col-span-2 flex items-top gap-2">
                    <input type="checkbox" ref="acceptionPrivacyPolicyCheckbox" v-model="privacyPolicyAccepted" class="cursor-pointer rounded mt-[2px]">
                    <p class="block text-sm">Я ознакомился и принимаю <a href="https://qkassa.ru/privacy-policy/" class="text-blue-600">пользовательское соглашение</a></p>
                </label>
                <button @click="executeCaptcha" class="cursor-pointer col-span-2 flex items-top gap-2 mb-4">
                    <input type="checkbox" ref="acceptionCaptchaTokenCheckbox" :disabled="capcthaToken" :checked="capcthaToken" class="cursor-pointer rounded mt-[2px]">
                    <p class="block text-sm">Я подтверждаю, что я не робот</p>
                </button>
                <button @click="sendRequestToSignUp" type="button" class="col-span-2 w-full bg-custom-blue hover:bg-custom-blue-hover text-center text-white font-medium rounded-lg text-sm px-5 py-2 mb-4">Создать аккаунт</button>
                <div class="col-span-2 flex items-center flex-col gap-1 text-sm">
                    <p>Уже есть аккаунт?</p>
                    <router-link :to="{'name': 'sign-in'}" class="text-blue-600 cursor-pointer">Войти в аккаунт</router-link>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import TextInput from '@/components/InputComponents/TextInput.vue';
    import PhoneInputComponent from '@/components/InputComponents/PhoneInputComponent.vue';

    export default {
        name: "SignIn",
        components: {
            TextInput,
            PhoneInputComponent,
        },
        computed: {

        },
        data() {
            return {                
                name: null,
                username: null,
                phone: null,
                privacyPolicyAccepted: false,
                capcthaToken: null,
                signUpCompleted: false,
            }
        },
        methods: {
            validateData() {
                const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
                if (!this.username) {
                    const usernameInput = this.$refs.usernameInput.$refs.textInput;
                    usernameInput.setCustomValidity("Введите ваш email");
                    usernameInput.reportValidity();
                    return false;
                }
                if (!emailRegex.test(this.username)) {
                    const usernameInput = this.$refs.usernameInput.$refs.textInput;
                    usernameInput.setCustomValidity("Введите корректный email");
                    usernameInput.reportValidity();
                    return false;
                }
                if (!this.name) {
                    const nameInput = this.$refs.nameInput.$refs.textInput;
                    nameInput.setCustomValidity("Введите ваше имя");
                    nameInput.reportValidity();
                    return false;
                }
                if (!this.phone) {
                    const phoneInput = this.$refs.phoneInput.$refs.phoneInput;
                    phoneInput.setCustomValidity("Введите ваш номер телефона");
                    phoneInput.reportValidity();
                    return false;
                }
                if (!this.$globalMethods.validatePhone(this.phone)) {
                    const phoneInput = this.$refs.phoneInput.$refs.phoneInput;
                    phoneInput.setCustomValidity("Введите корректный номер телефона");
                    phoneInput.reportValidity();
                    return false;
                }
                if (!this.privacyPolicyAccepted) {
                    const acceptionPrivacyPolicyCheckbox = this.$refs.acceptionPrivacyPolicyCheckbox;
                    acceptionPrivacyPolicyCheckbox.setCustomValidity("Необходимо принять пользовательское соглашение")
                    acceptionPrivacyPolicyCheckbox.reportValidity();
                    return false;
                }
                if (!this.capcthaToken) {
                    const acceptionCaptchaTokenCheckbox = this.$refs.acceptionCaptchaTokenCheckbox;
                    acceptionCaptchaTokenCheckbox.setCustomValidity("Подтвердите, что вы не робот")
                    acceptionCaptchaTokenCheckbox.reportValidity();
                    return false;
                }
                return true;
            },
            async sendRequestToSignUp() {
                if (!this.validateData()) {
                    return;
                }
                const data = {
                    username: this.username,
                    name: this.name,
                    phone: this.phone,
                    captcha: this.capcthaToken
                }
                
                const result = await this.$store.dispatch("fetchSignUp", data);
                if (result.successfully) {
                    this.signUpCompleted = true;
                } else {
                    if (result.error == "invalid captcha") {
                        this.capcthaToken = null;
                    } else if (result.error == "User already exists.") {
                        this.capcthaToken = null;
                        this.$notify("Пользователь с таким email уже существует в системе", "red");
                    }
                }
            },
            async executeCaptcha() {
                try {
                    const token = await this.$recaptcha("signup");
                    this.capcthaToken = token;
                } catch (error) {
                    this.$notify("Упс! что-то пошло не так...", "red");
                    console.error(error.stack);
                }
            },
        },
        mounted() {
            
        },
    }
</script>